/* Angular Component */
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Tag } from "../../../domain/tag";

@Component({
  selector: "tag",
  templateUrl: "./tag.component.html",
  styleUrls: ["./tag.component.scss"],
})
export class TagComponent {
  @Input()
  tag: Tag;

  @Output()
  onDeleteTag = new EventEmitter();

  constructor() {}

  /**
   * Initializing component
   * @return void
   */
  ngOnInit() {}

  /**
   * Dispatch Remove Tag
   * @param event
   */
  deleteTag() {
    this.onDeleteTag.emit(this.tag);
  }
}
